module.exports = __webpack_public_path__ + "static/media/server alt.88b6dd8f.png";